<template>
  <div class="search-page flex flex-col justify-between h-full">
    <WFSearch
      ref="search"
      :showLogo="true"
      :showName="false"
      :showOutputField="false"
      :showKeyboard="!mobile"
      @clicked="onPOIClick"
      class="wf-component wf-search h-full text-xl flex flex-col align-center th-list"
    >
      <template v-slot="slotProps">
        <ListPOI
          :poi="slotProps.poi"
          @onPOIClick="onPOIClick(slotProps.poi)"
          class="wf-list-item"
        ></ListPOI>
      </template>
    </WFSearch>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ListPOI from "./ListPOI.vue";

export default {
  components: {
    ListPOI,
  },
  computed: {
    ...mapState("wf", ["language", "pois", "mobile"]),
  },
  data() {
    return {
      currentTab: "all",
      shortcuts: false,
      currentGroup: null,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.search.setOutput("search-output");
      this.$refs.search.addLayout("no", {
        name: "Norwegian",
        keyboard: "Norwegian",
        local_name: "English",
        lang: "no",
        keys: {
          default: [
            ["q", "w", "e", "r", "t", "y", "u", "i", "o", "p", "\u00E5"],
            ["a", "s", "d", "f", "g", "h", "j", "k", "l", "\u00f8", "\u00e6"],
            [
              "z",
              "x",
              "c",
              "v",
              "b",
              "n",
              "m",
              ".",
              "&",
              { key: "\u00AB", action: ["backspace"] },
            ],
            [{ key: "\u02FD", cls: "key_spacebar" }],
          ],
        },
      });
      this.$refs.search.addLayout("en", {
        name: "English",
        keyboard: "US International",
        local_name: "English",
        lang: "en",
        keys: {
          default: [
            ["q", "w", "e", "r", "t", "y", "u", "i", "o", "p"],
            ["a", "s", "d", "f", "g", "h", "j", "k", "l"],
            [
              "z",
              "x",
              "c",
              "v",
              "b",
              "n",
              "m",
              ".",
              "&",
              { key: "\u00AB", action: ["backspace"] },
            ],
            [{ key: "\u02FD", cls: "key_spacebar" }],
          ],
        },
      });
      this.$refs.search.addLayout("et", {
        name: "Estonian",
        keyboard: "Estonian",
        local_name: "Estonian",
        lang: "et",
        keys: {
          default: [
            ["q", "w", "e", "r", "t", "y", "u", "i", "o", "p", "\u00FC", "\u00F5"],
            ["a", "s", "d", "f", "g", "h", "j", "k", "l", "\u00F6", "\u00E4"],
            [
              "z",
              "x",
              "c",
              "v",
              "b",
              "n",
              "m",
              ".",
              "&",
              { key: "\u00AB", action: ["backspace"] },
            ],
            [{ key: "\u02FD", cls: "key_spacebar" }],
          ],
        },
      });
    });
  },
  methods: {
    showTab(tab) {
      this.currentTab = tab;
    },
    shortcutClicked(nearest) {
      this.$emit("clicked", nearest);
    },
    onPOIClick(poi) {
      this.$emit("clicked", poi);
    },
    filterByGroup(group) {
      this.$store.dispatch("wf/SET_FILTERED_POIS", group.getPOIs());
      this.currentGroup = group;
      if (this.$refs["searchscroll"]) {
        this.$refs["searchscroll"].reset();
      }
    },
    filterAll() {
      this.$store.dispatch("wf/SET_FILTERED_POIS", this.pois);
      this.currentGroup = null;

      if (this.$refs["searchscroll"]) {
        this.$refs["searchscroll"].reset();
      }
    },
  },
};
</script>

<style lang="postcss">
.search-page {

  @media (orientation: portrait) {  
    .keyboard-key_spacebar {
      width: 60% !important;
    }
  }

  @media (orientation: lanscape) {  
    .keyboard-key_spacebar {
      width: 80% !important;
    }
  }
  .wf-search-results {
    padding: 1.2rem;
    padding-left: 3.2rem;
    padding-right: 3.2rem;
    min-height: 3rem;
    text-align: center;
    font-weight: 500;
    font-size: 2.4rem;
    flex-grow: 1;
  }

  .wf-no-results {
    padding-top: 10rem;
  }

  .wf-search-container {
    margin: 0 !important;
    padding: 0 !important;
  }

  .wf-search-input-container {
    margin-bottom: 4rem;
    width: 100%;

    input {
      width: 100%;
      border: 1px solid #ccc !important;
    }
  }

  .wf-keyboard {
    background-color: var(--th-neutral2);
    padding: 1.6rem;
    padding-top: 4rem;
    gap: 0.4rem;

  }

  .keyboard-row {
    gap: 0.4rem;
    width: 100%;
    justify-content: center;
  }

  .keyboard-key {
    background-color: white;
    width: 4.8rem !important;
    height: 4.8rem !important;
    line-height: 4.8rem !important;
    box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.1);
    font-size: 2rem;
    font-weight: 500;
    text-transform: uppercase;
  }

  .keyboard-key:active {
    background-color: var(--th-active);
    color: var(--th-active-content);
  }

  .keyboard-key_spacebar {
    min-width: 40%;
    font-size: 400%;
    line-height: 0.7 !important;
  }

  .pois-content {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    overflow: hidden;
  }

  .poi-groups {
    padding: 1rem;
  }

  .poi-groups .wf-list {
    display: grid;
    gap: 1.2rem;
    grid-template-columns: 1fr 1fr 1fr;
  }

  .poi-groups .wf-list-item {
    height: 3.6em;
    padding: 0.4em;
    font-weight: 500;
    text-align: center;
    line-height: 1.4em;
    vertical-align: middle;

    display: flex;
    flex-direction: column;
    justify-content: center;

    &.active {
      background-color: black;
      color: white;
    }
  }
}
/* ===== 4K PORTRAIT ONLY - Search ===== */
@media (orientation: portrait) and (min-width: 2160px) {
  .search-page .wf-search-results {
    font-size: 4.8rem !important;
    padding: 2.4rem 6.4rem !important;
  }
  
  /* Search bar - 2x */
  .search-page .wf-search-input-container {
    margin-bottom: 8rem !important;
  }
  
  .search-page .wf-search-input-container input {
    font-size: 4rem !important;
    height: 10rem !important;
    padding: 2.4rem 4.8rem !important;
    border-width: 2px !important;
  }
  
  /* Search icon - 2x */
  .search-page .wf-search-input-container .wf-icon,
  .search-page .wf-search-input-container button {
    width: 8rem !important;
    height: 8rem !important;
  }
  
  .search-page .wf-search-input-container .wf-icon svg {
    width: 6.4rem !important;
    height: 6.4rem !important;
  }
  
  /* Search results POI names - 2x */
  .search-page .wf-poi-list-item .leading-normal,
  .search-page .wf-poi-list-item .text-16,
  .search-page .wf-translatable {
    font-size: 5.2rem !important;
    line-height: 3 !important;
  }
  
  /* Search results list items - 2x */
  .search-page .wf-poi-list-item {
    min-height: 14rem !important;
    padding: 3.2rem 2.4rem !important;
  }
  
  /* Keyboard - 2x */
  .search-page .wf-keyboard {
    padding: 3.2rem 3.2rem 8rem 3.2rem !important;
    gap: 0.8rem !important;
  }
  
  .search-page .keyboard-row {
    gap: 0.8rem !important;
  }
  
  .search-page .keyboard-key {
    width: 9.6rem !important;
    height: 9.6rem !important;
    line-height: 9.6rem !important;
    font-size: 4rem !important;
  }
  
  .search-page .keyboard-key_spacebar {
    width: 60% !important;
    font-size: 800% !important;
  }
}
</style>
